module.exports = __webpack_public_path__ + "img/T-box Icon - charcoal.73d6d999.svg";